import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { usePathFactory } from "@sia/style-guide";
import useEvaluationMasterKeyWorkflow from "pages/MasterKey/useEvaluationMasterKeyWorkflow";

const useEvaluationsMasterKeyModal = ({ translate, redirectUrl, onAuthenticated, onContinueWithoutKey }) => {
  const history = useHistory();
  const pathFactory = usePathFactory();
  const navigate = () => {
    if (redirectUrl) history.push(pathFactory.create(redirectUrl));
  };
  const completeAuthenticated = () => {
    onAuthenticated?.();
    navigate();
  };
  const completeWithoutKey = () => {
    onContinueWithoutKey?.();
    navigate();
  };
  const workflow = useEvaluationMasterKeyWorkflow({
    translate,
    initialMode: "enter-key",
    onAuthenticated: completeAuthenticated,
    onWithoutKey: completeWithoutKey,
    onClose: completeWithoutKey,
  });

  useEffect(() => {
    workflow.resetInputs("enter-key");
  }, [redirectUrl]);

  return {
    masterKeyMode: workflow.masterKeyMode,
    enteredKey: workflow.key,
    oldKey: workflow.oldKey,
    newKey: workflow.key,
    invalidText: workflow.invalidText,
    invalidTextOldKey: workflow.invalidTextOldKey,
    // Keep both contracts so this works with both the refactored modal
    // and EvaluationsMasterKeyModalContent directly.
    handleEnteredKeyChange: workflow.setKey,
    handleOldKeyChange: workflow.setOldKey,
    handleNewKeyChange: workflow.setKey,
    handleModeChange: workflow.changeMode,
    onEnteredKeyChange: workflow.setKey,
    onOldKeyChange: workflow.setOldKey,
    onNewKeyChange: workflow.setKey,
    onModeChange: workflow.changeMode,
    handleSubmit: workflow.submit,
    handleCancel: () => workflow.close(true),
  };
};

export default useEvaluationsMasterKeyModal;
